// A person's account can be limited to one platform (the full dashboard or the
// ops app). When they sign in on the wrong one the API refuses with
// PLATFORM_ACCESS_DENIED and we send them to the other host instead of
// showing a dead-end error. The other host is derived from the current one:
//   dashboard.maxcei.pt <-> ops.maxcei.pt,  localhost:9000 <-> ops.localhost:9000
const DASHBOARD_PREFIX = "dashboard.";
const OPS_PREFIX = "ops.";

type HostLocation = Pick<Location, "protocol" | "hostname" | "port">;

const urlFor = ({ protocol, port }: HostLocation, hostname: string) =>
  `${protocol}//${hostname}${port ? `:${port}` : ""}/`;

const isLocalHost = (hostname: string) => hostname === "localhost" || hostname.startsWith("127.");

export const getOpsUrl = (location: HostLocation = window.location): string => {
  const hostname = location.hostname.toLowerCase();
  const base = hostname.startsWith(DASHBOARD_PREFIX)
    ? hostname.slice(DASHBOARD_PREFIX.length)
    : hostname;

  return urlFor(location, `${OPS_PREFIX}${base}`);
};

export const getDashboardUrl = (location: HostLocation = window.location): string => {
  const hostname = location.hostname.toLowerCase();
  const base = hostname.startsWith(OPS_PREFIX) ? hostname.slice(OPS_PREFIX.length) : hostname;

  return urlFor(location, isLocalHost(base) ? base : `${DASHBOARD_PREFIX}${base}`);
};
